<template>
  <div class="nlp__search-bar-box">
    <div
      class="nlp__search-bar-background"
      :class="{ 'nlp__search-bar-background--error': errorMessage }"
    >
      <div class="nlp__search-bar-select">
        <NlpCoinSelect :parent-block="parentBlock" />
      </div>
      <div class="nlp__search-bar-input">
        <input
          v-model="search"
          class="nlp__search-bar-input-field"
          placeholder="Enter the wallet address"
          type="text"
          @focus="handleFocus"
        >
      </div>
      <div class="nlp__search-bar-button">
        <NlpButton 
          :full-width="isNlpMobile"
          primary
          text="Check for Free"
          @button-click="searchData"
        />
      </div>
    </div>
    <div
      v-if="errorMessage"
      class="nlp__search-bar-error"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
// Components
import NlpCoinSelect from '@/pages/landing-page/ui-components/NlpCoinSelect.vue'
import NlpButton from '@/pages/landing-page/ui-components/NlpButton.vue'

// Vuex
import { mapState } from 'vuex'

// Mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin'

export default {
  name: 'NlpSearchBar',
  components: {
    NlpCoinSelect,
    NlpButton,
  },
  mixins: [deviceWidthMixin],
  props: {
    parentBlock: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      search: '',
      errorMessage: '',
    }
  },
  computed: {
    ...mapState('analytics', ['coinType', 'coinData']),
  },
  methods: {
    async searchData() {
      if (new RegExp(this.coinData.addressRegex).test(this.search)) {
        await this.$router.push({
          name: 'report',
          query: {
            type: this.coinType,
            address: this.search,
          },
        })
      } else {
        this.errorMessage = 'Search value is not valid.'
      }
    },
    handleFocus() {
      this.errorMessage = ''
      this.search = ''
    },
  },
}
</script>

<style>
.nlp__search-bar-box {
  width: 640px;
  position: relative;
}
.nlp__search-bar-background {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 6px 0 14px;
  background-color: #fff;
  border: 1px solid #E2E9F6;
  border-radius: 30px;
  transition: background-color 0.3s ease, border 0.3s ease;
}
.nlp__search-bar-background:hover {
  background-color: #F7F9FC;
  border: 1px solid #C3CBD9;
}
.nlp__search-bar-background--error,
.nlp__search-bar-background--error:hover {
  background-color: #FFFAFB;
  border: 1px solid #F1104E;
}
.nlp__search-bar-input {
  flex: 1;
}
.nlp__search-bar-input-field {
  width: 100%;
  height: 60px;
  padding: 0 16px;
  border: none;
  background-color: transparent;
  font-weight: 400;
  font-size: 16px;
  line-height: 1;
  color: #5A627D;
}
.nlp__search-bar-input-field:focus {
  outline: none;
  box-shadow: none;
}
.nlp__search-bar-error {
  margin-left: 14px;
  color: var(--Red-Accent, #F1104E);
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;  
  position: absolute;
  bottom: -26px;
}

@media (max-width: 767px) {
  .nlp__search-bar-box {
    width: 100%;
    padding-bottom: 60px;
  }
  .nlp__search-bar-background {
    max-width: 100%;
    height: 48px;
    padding: 0 0 0 12px;
  }
  .nlp__search-bar-input-field {
    height: 48px;
    padding: 0 24px;
    font-size: 14px !important;
  }
  .nlp__search-bar-button {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}
</style>